function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { memo, useRef } from 'react';
import { useDrag } from '../../hooks/drag';
export var Direct;

(function (Direct) {
  Direct["ALL"] = "all";
  Direct["LEFT_UP"] = "left-up";
  Direct["UP"] = "up";
  Direct["RIGHT_UP"] = "right-up";
  Direct["LEFT"] = "left";
  Direct["RIGHT"] = "right";
  Direct["LEFT_DOWN"] = "left-down";
  Direct["DOWN"] = "down";
  Direct["RIGHT_DOWN"] = "right-down";
})(Direct || (Direct = {}));

export var CropperDrag = memo(function (props) {
  var onDragEnd = props.onDragEnd,
      onDragging = props.onDragging,
      direct = props.direct,
      setType = props.setType,
      extra = _objectWithoutProperties(props, ["onDragEnd", "onDragging", "direct", "setType"]);

  var dragRef = useRef(null);
  useDrag(dragRef, {
    onDragStart: function onDragStart() {
      return setType(direct);
    },
    onDragging: onDragging,
    onDragEnd: onDragEnd
  });
  return React.createElement("div", Object.assign({
    ref: dragRef
  }, extra));
});
CropperDrag.displayName = 'CropperDrag';